import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Revolut icon used in the main menu.
 * Uses the provided official logo URL and keeps standard MUI icon sizing.
 */
const RevolutIcon: React.FC<SvgIconProps> = (props) => {
  const revolutIconUrl = 'https://www.logo.wine/a/logo/Revolut/Revolut-Icon-Logo.wine.svg';

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <image
        href={revolutIconUrl}
        width="24"
        height="24"
        preserveAspectRatio="xMidYMid meet"
      />
    </SvgIcon>
  );
};

export default RevolutIcon;
